import Style from "./Style.module.css";
import {FormControl, FormGroup} from "react-bootstrap";
import React, {useEffect, useState} from "react";
import {useNavigate, useSearchParams} from "react-router-dom";
import {setPassword} from "../api/UserService";
import * as UserService from "../api/UserService";

function RestPassword() {
    const [password, setPassword] = useState("")
    const [passError, setPassError] = useState(false)
    const [passwordRepeat, setPasswordRepeat] = useState("")
    const [showError, setShowError] = useState(false)
    const [errorMessage, setErrorMessage] = useState("")
    const [passwordChanged, setPasswordChanged] = useState(false)
    const [queryParams] = useSearchParams()
    const nav = useNavigate()

    const passwordsNotEqualErrorText = "Введені паролі не однакові"
    const tokenExpiredErrorText = "Щось пішло не так, запросіть зміну пароля ще раз"

    const isPassValid = (pass) => {
        return pass.length >= 8
    }

    function ResolvePassword(event) {
        let pass = event.target.value
        setPassword(pass)
        setPassError(!isPassValid(pass))
    }

    function ResolvePasswordRepeat(event) {
        setPasswordRepeat(event.target.value)
    }

    function sendSetPasswordRequest() {
        if (password === passwordRepeat) {
            UserService.setPassword(password, queryParams.get("token"), () => {
                setPasswordChanged(true)
            }, () => {
                setShowError(true)
                setErrorMessage(tokenExpiredErrorText)
            })
        }
    }

    useEffect(() => {
        if (password !== passwordRepeat && passwordRepeat !== "") {
            setShowError(true)
            setErrorMessage(passwordsNotEqualErrorText)
        }
        if (password === passwordRepeat) {
            setShowError(false)
        }
    }, [password, passwordRepeat]);


    if (passwordChanged) {
        return (
            <div className={Style.startPageMainContainer}>
                <div className={Style.setupPageBlocks}>
                    <header>Пароль успішно змінено!</header>
                    <div className={`${Style.defaultButtonColourAndText} ${Style.setupPageBlocks}`}
                         onClick={() => {
                             nav("/")
                         }}>Повернутись на головну
                    </div>
                </div>
            </div>
        )

    } else {
        return (
            <div className={Style.startPageMainContainer}>
                <div className={Style.setupPageBlocks}>
                    <header>Введіть новий пароль</header>
                    <FormGroup>
                        <FormControl
                            placeholder={"Новий пароль"}
                            aria-label="Password"
                            aria-describedby="basic-addon1"
                            value={password}
                            type={"password"}
                            onChange={event => ResolvePassword(event)}
                        />
                        {passError &&
                            <small style={{color: "white"}}>Пароль має містити від 8ми символів!</small>
                        }
                    </FormGroup>
                    <br></br>
                    <FormControl
                        placeholder={"Повторіть пароль"}
                        aria-label="Password"
                        aria-describedby="basic-addon1"
                        value={passwordRepeat}
                        type={"password"}
                        onChange={event => ResolvePasswordRepeat(event)}
                        // type={"password"}
                    />
                    {showError &&
                        <div>{errorMessage}</div>}
                    <div className={Style.resetPasswordControls}>
                        <div className={Style.defaultButtonColourAndText}
                             onClick={() => nav("/login")}
                        >Скасувати
                        </div>
                        <div className={Style.defaultButtonColourAndText}
                             onClick={sendSetPasswordRequest}>Змінити
                        </div>
                    </div>

                </div>
            </div>

        )
    }

}

export default RestPassword